/** @file quadsOf: this frame's quads layer input (every quad with the view on; else only a file drop target). */
import type { QuadsInput } from './quadOverlay';
import { quadEditOf } from './quadEditOf';
import type { ViewportCtx } from './viewportCtx';

/**
 * Edit mode with a drawn puppet, and the quads view on or a file dragged over a part: the placed impostors, the
 * drawables, hover and drop target, the running quad drag or typed value (`quadEditOf`), camera, view and scene units per CSS px; else null.
 */
export function quadsOf(ctx: ViewportCtx, px: number): QuadsInput | null {
  const p = ctx.puppet();
  if (ctx.mode !== 'edit' || p === null || ctx.scene === null || ctx.profile === null) return null;
  const all = ctx.store.getState().camera.quads;
  if (!all && ctx.quad.drop < 0) return null;
  const state = p.instance.state();
  return {
    list: state.list, count: state.count, drawables: p.bundle.puppet.drawables, hovered: all ? ctx.quad.hover : -1, drop: ctx.quad.drop, all,
    edit: quadEditOf(ctx), camera: ctx.scene.camera.contract(), profile: ctx.profile, view: ctx.scene.camera.view(), px,
  };
}
